import { MotionConfig } from "framer-motion";
import NavBar from "./components/NavBar";
import Home from "./components/Home";
import SocialLinks from "./components/SocialLinks";
import About from "./components/About";
import WorkExperience from "./components/WorkExperience";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Contact from "./components/Contact";


function App() {
  return (
    <MotionConfig reducedMotion="user">
      <div className="min-h-screen bg-[#030712] text-slate-200 antialiased selection:bg-sky-500/30 selection:text-white">
        <NavBar />
        <Home />
        <WorkExperience />
        <About />
        <Projects />
        <Experience />
        <Contact />
        <SocialLinks />
      </div>
    </MotionConfig>
  );
}

export default App;

